module.exports = __webpack_public_path__ + "img/bg-audio-0.8ff1265f.png";